class ProductVariantPickerService {
  static shouldShow(element, source) {
    return (
      element.options["confirmation-type"] == "cart" ||
      !source ||
      source.toLowerCase() == "convertflow" ||
      (element.options["confirmation-type"] == "product" &&
        source == "ShopifyGraphql" &&
        element.options["variant-picker-show"] == "true")
    );
  }
}

if (typeof window !== "undefined") {
  window.ProductVariantPickerService = ProductVariantPickerService;
}

export default ProductVariantPickerService;
